module.exports = __webpack_public_path__ + "static/media/ang.6ec92ba4.JPG";